export default {
  'pages.covenantDevice.mac': 'Endereço MAC',
  'pages.admin.providerCard.config.grpcAddr': 'Endereço gRPC',
  'pages.covenantDevice.cardTitle': 'Gerenciamento de Dispositivos Contratuais',
  'pages.admin.whitelist.mac': 'Endereço MAC',
  'pages.covenantDevice.operations': 'Operações',
  'pages.covenantDevice.expireTime': 'Data de Expiração',
  'pages.covenantDevice.updateTime': 'Hora de Atualização',
  'pages.unbindDevice.titleAdmin': 'Desvincular Dispositivo (Administrador Necessário)',
  'pages.unbindDevice.inputPlaceholder': 'Por favor, insira o ID do dispositivo',
  'pages.unbindDevice.unbind': 'Desvincular',
  'pages.unbindDevice.unbinding': 'Desvinculando...',
  'pages.unbindDevice.success': 'Desvinculação bem-sucedida',
  'pages.unbindDevice.fail': 'Desvinculação falhou',
  'pages.layouts.userLayout.title': 'Console de Gerenciamento',
  'pages.login.accountLogin.tab': 'Login da Conta',
  'pages.login.accountLogin.errorMessage':
    'Nome de usuário/senha incorretos(admin/ant.design)',
  'pages.login.failure': 'Login falhou, por favor tente novamente!',
  'pages.login.success': 'Login bem-sucedido!',
  'pages.login.username.placeholder': 'Nome de usuário: admin ou user',
  'pages.login.username.required': 'Por favor, insira seu nome de usuário!',
  'pages.login.password.placeholder': 'Senha: ant.design',
  'pages.login.password.required': 'Por favor, insira sua senha!',
  'pages.login.phoneLogin.tab': 'Login por Telefone',
  'pages.login.phoneLogin.errorMessage': 'Erro no Código de Verificação',
  'pages.login.phoneNumber.placeholder': 'Número de Telefone',
  'pages.login.phoneNumber.required': 'Por favor, insira seu número de telefone!',
  'pages.login.phoneNumber.invalid': 'Número de telefone inválido!',
  'pages.login.captcha.placeholder': 'Código de Verificação',
  'pages.login.captcha.required': 'Por favor, insira o código de verificação!',
  'pages.login.phoneLogin.getVerificationCode': 'Obter Código',
  'pages.getCaptchaSecondText': 'seg',
  'pages.login.rememberMe': 'Lembrar-me',
  'pages.login.forgotPassword': 'Esqueceu a Senha?',
  'pages.login.submit': 'Entrar',
  'pages.login.loginWith': 'Entrar com:',
  'pages.login.registerAccount': 'Registrar Conta',
  'pages.welcome.link': 'Bem-vindo',
  'pages.welcome.alertMessage':
    'Componentes pesados mais rápidos e fortes foram lançados.',
  'pages.404.subTitle': 'Desculpe, a página que você visitou não existe.',
  'pages.404.buttonText': 'Voltar ao Início',
  'pages.admin.subPage.title': 'Esta página só pode ser visualizada pelo Administrador',
  'pages.admin.subPage.alertMessage':
    'Umi ui foi lançado, bem-vindo a usar npm run ui para começar a experiência.',
  'pages.searchTable.createForm.newRule': 'Nova Regra',
  'pages.searchTable.updateForm.ruleConfig': 'Configuração da regra',
  'pages.searchTable.updateForm.basicConfig': 'Informações Básicas',
  'pages.searchTable.updateForm.ruleName.nameLabel': 'Nome da Regra',
  'pages.searchTable.updateForm.ruleName.nameRules':
    'Por favor, insira o nome da regra!',
  'pages.searchTable.updateForm.ruleDesc.descLabel': 'Descrição da Regra',
  'pages.searchTable.updateForm.ruleDesc.descPlaceholder':
    'Por favor, insira pelo menos cinco caracteres',
  'pages.searchTable.updateForm.ruleDesc.descRules':
    'Por favor, insira uma descrição da regra com pelo menos cinco caracteres!',
  'pages.searchTable.updateForm.ruleProps.title': 'Configurar Propriedades',
  'pages.searchTable.updateForm.object': 'Objeto de Monitoramento',
  'pages.searchTable.updateForm.ruleProps.templateLabel': 'Modelo de Regra',
  'pages.searchTable.updateForm.ruleProps.typeLabel': 'Tipo de Regra',
  'pages.searchTable.updateForm.schedulingPeriod.title':
    'Definir Período de Agendamento',
  'pages.searchTable.updateForm.schedulingPeriod.timeLabel': 'Hora de Início',
  'pages.searchTable.updateForm.schedulingPeriod.timeRules':
    'Por favor, escolha uma hora de início!',
  'pages.searchTable.titleDesc': 'Descrição',
  'pages.searchTable.ruleName': 'Nome da regra é obrigatório',
  'pages.searchTable.titleCallNo': 'Número de Chamadas de Serviço',
  'pages.searchTable.titleStatus': 'Status',
  'pages.searchTable.nameStatus.default': 'padrão',
  'pages.searchTable.nameStatus.running': 'executando',
  'pages.searchTable.nameStatus.online': 'online',
  'pages.searchTable.nameStatus.abnormal': 'anormal',
  'pages.searchTable.titleUpdatedAt': 'Último Agendamento em',
  'pages.searchTable.exception': 'Por favor, insira o motivo da exceção!',
  'pages.searchTable.titleOption': 'Opção',
  'pages.searchTable.config': 'Configuração',
  'pages.searchTable.subscribeAlert': 'Inscrever-se em alertas',
  'pages.searchTable.title': 'Formulário de Consulta',
  'pages.searchTable.new': 'Novo',
  'pages.searchTable.chosen': 'escolhido',
  'pages.searchTable.item': 'item',
  'pages.searchTable.totalServiceCalls': 'Número Total de Chamadas de Serviço',
  'pages.searchTable.tenThousand': '0000',
  'pages.searchTable.batchDeletion': 'exclusão em lote',
  'pages.searchTable.batchApproval': 'aprovação em lote',
  
  // Agents page related text
  'pages.agents.search.placeholder': 'Pesquisar agentes',
  'pages.agents.create.button': 'Criar Agente',
  'pages.agents.addDevice.button': 'Adicionar Dispositivo',
  'pages.agents.create.modal.title': 'Criar Agente',
  'pages.agents.create.modal.nameLabel': 'Nome do Agente',
  'pages.agents.create.modal.placeholder': 'Por favor, insira o nome do agente',
  'pages.agents.card.id': 'ID',
  'pages.agents.card.voiceModel': 'Modelo de Voz',
  'pages.agents.card.languageModel': 'Modelo de Linguagem',
  'pages.agents.card.lastChat': 'Último Chat',
  'pages.agents.card.conversationId': 'ID da Conversa',
  'pages.agents.card.clearConversation': 'Limpar ID da Conversa',
  'pages.agents.card.clearConversation.success': 'ID da conversa limpo',
  'pages.agents.card.clearConversation.error': 'Falha ao limpar ID da conversa',
  'pages.agents.card.configRole': 'Configurar Papel',
  'pages.agents.card.voiceRecognition': 'Reconhecimento de Voz',
  'pages.agents.card.voiceRecognition.developing': 'Recurso em desenvolvimento, aguarde',
  'pages.agents.card.historyDialog': 'Diálogo do Histórico',
  'pages.agents.card.manageDevice': 'Gerenciar Dispositivos',
  'pages.agents.card.addDevice': 'Adicionar Dispositivo',
  'pages.agents.loading': 'Carregando lista de agentes...',
  'pages.agents.reload': 'Recarregar',
  'pages.agents.empty.title': 'Nenhum agente disponível',
  'pages.agents.empty.createFirst': 'Crie seu primeiro agente',
  'pages.agents.delete.title': 'Confirmar Exclusão do Agente',
  'pages.agents.delete.content': 'Após excluir o agente, todas as configurações relacionadas (incluindo registros de conversas relacionados ao dispositivo) não podem ser recuperadas. Tem certeza de que deseja excluir?',
  'pages.agents.delete.confirm': 'Confirmar Exclusão',
  'pages.agents.fetch.error': 'Falha ao buscar lista de agentes',
  'pages.agents.network.error': 'Erro de rede, tente novamente mais tarde',
  'pages.agents.speed.patient': 'Paciente',
  'pages.agents.speed.normal': 'Normal',
  'pages.agents.speed.fast': 'Rápido',
  'pages.agents.lastChat.none': 'Nenhum',
  'pages.agents.language.chinese': 'Chinês',
  'pages.agents.loading.tts.error': 'Falha ao carregar vozes TTS',
  'pages.agents.loading.llm.error': 'Falha ao carregar provedores LLM',
  'pages.agents.sort.id': 'Ordenar por ID',
  'pages.agents.sort.updatedAt': 'Ordenar por última modificação',
  'pages.agents.sort.lastConversationAt': 'Ordenar por última conversa',
  
  // Register page related text
  'pages.register': 'Registrar',
  'pages.register.title': 'Registrar',
  'pages.register.form.title': 'Registrar Nova Conta',
  'pages.register.submit': 'Registrar',
  'pages.register.username.placeholder': 'Por favor, insira o nome de usuário',
  'pages.register.username.required': 'Por favor, insira o nome de usuário!',
  'pages.register.username.min': 'Nome de usuário deve ter pelo menos 4 caracteres',
  'pages.register.email.placeholder': 'Por favor, insira o email',
  'pages.register.email.required': 'Por favor, insira o email!',
  'pages.register.email.invalid': 'Por favor, insira um endereço de email válido!',
  'pages.register.password.placeholder': 'Por favor, insira a senha',
  'pages.register.password.required': 'Por favor, insira a senha!',
  'pages.register.password.min': 'Senha deve ter pelo menos 6 caracteres',
  'pages.register.password.pattern': 'Senha deve conter letras maiúsculas, minúsculas e números',
  'pages.register.confirmPassword.placeholder': 'Por favor, confirme a senha',
  'pages.register.confirmPassword.required': 'Por favor, confirme a senha!',
  'pages.register.confirmPassword.min': 'Senha deve ter pelo menos 6 caracteres',
  'pages.register.error.passwordMismatch': 'As duas senhas não coincidem',
  'pages.register.error.registerFailed': 'Registro falhou, tente novamente!',
  'pages.register.success': 'Registro bem-sucedido!',
  
  // Login page related text
  'pages.login.title': 'Console de Gerenciamento de Chat Anime AI',
  'pages.login.actionIcons.notImplemented': 'Ainda não implementado, em breve',
  'pages.login.mobile.captchaError': 'Erro no código de verificação',
  'pages.login.captcha.success': 'Código de verificação enviado com sucesso! Código: 1234',
  'pages.login.forgotPassword.contactAdmin': 'Entre em contato com o administrador',
  'pages.login.mobile.notAvailable': 'Este recurso ainda não está disponível, use o login da conta',
  
  // AgentSetting page related text
  'pages.agentSetting.title': 'Configurar Papel',
  'pages.agentSetting.back': 'Voltar',
  'pages.agentSetting.roleTemplate.title': 'Modelo de Papel',
  'pages.agentSetting.roleTemplate.label': 'Modelo',
  'pages.agentSetting.template.taiwanGirlfriend': 'Namorada de Taiwan',
  'pages.agentSetting.template.potato': 'Batata',
  'pages.agentSetting.template.englishTutor': 'Tutor de Inglês',
  'pages.agentSetting.template.curiousBoy': 'Menino Curioso',
  'pages.agentSetting.template.puppyLeader': 'Líder Filhote',
  'pages.agentSetting.basicConfig.title': 'Configuração Básica',
  'pages.agentSetting.assistantName.label': 'Nome do Assistente',
  'pages.agentSetting.assistantName.placeholder': 'Por favor, insira o nome do assistente',
  'pages.agentSetting.assistantName.required': 'Por favor, insira o nome do assistente',
  'pages.agentSetting.dialogLanguage.label': 'Idioma do Diálogo',
  'pages.agentSetting.dialogLanguage.placeholder': 'Selecione o idioma do diálogo',
  'pages.agentSetting.voiceType.label': 'Tipo de Voz',
  'pages.agentSetting.voiceType.placeholder': 'Selecione o tipo de voz',
  'pages.agentSetting.roleDescription.title': 'Descrição do Papel',
  'pages.agentSetting.roleDescription.label': 'Descrição do Papel',
  'pages.agentSetting.roleDescription.placeholder': 'Por favor, insira a descrição do papel',
  'pages.agentSetting.roleDescription.required': 'Por favor, insira a descrição do papel',
  'pages.agentSetting.languageModel.title': 'Modelo de Linguagem',
  'pages.agentSetting.languageModel.label': 'Modelo de Linguagem',
  'pages.agentSetting.languageModel.placeholder': 'Selecione o modelo de linguagem',
  'pages.agentSetting.languageModel.tip': 'Após mudar o modelo, é recomendado limpar a memória para evitar afetar a experiência do chat.',
  'pages.agentSetting.advancedSettings.expand': 'Expandir Configurações Avançadas',
  'pages.agentSetting.advancedSettings.collapse': 'Recolher Configurações Avançadas',
  'pages.agentSetting.recognitionSpeed.label': 'Velocidade de Reconhecimento de Fala',
  'pages.agentSetting.recognitionSpeed.placeholder': 'Selecione a velocidade de reconhecimento',
  'pages.agentSetting.speechSpeed.label': 'Velocidade da Fala',
  'pages.agentSetting.speechSpeed.placeholder': 'Selecione a velocidade da fala',
  'pages.agentSetting.pitchValue.label': 'Volume do Personagem',
  'pages.agentSetting.button.reset': 'Redefinir',
  'pages.agentSetting.button.save': 'Salvar',
  'pages.agentSetting.save.success': 'Salvar bem-sucedido',
  'pages.agentSetting.save.error': 'Falha ao salvar',
  'pages.agentSetting.save.missingId': 'ID do agente ausente, não foi possível salvar',
  'pages.agentSetting.load.tts.error': 'Falha ao carregar vozes TTS',
  'pages.agentSetting.speed.slow': 'Lento',
  'pages.agentSetting.speed.normal': 'Normal',
  'pages.agentSetting.speed.fast': 'Rápido',
  'pages.agentSetting.speed.patient': 'Paciente',
  'pages.agentSetting.language.chinese': 'Chinês',
  'pages.agentSetting.language.english': 'Inglês',
  'pages.agentSetting.language.spanish': 'Espanhol',
  'pages.agentSetting.language.french': 'Francês',
  'pages.agentSetting.language.german': 'Alemão',
  'pages.agentSetting.language.japanese': 'Japonês',
  'pages.agentSetting.language.korean': 'Coreano',
  'pages.agentSetting.language.portuguese': 'Português',
  'pages.agentSetting.language.arabic': 'Árabe',
  'pages.agentSetting.language.russian': 'Russo',
  'pages.agentSetting.language.italian': 'Italiano',
  'pages.agentSetting.language.turkish': 'Turco',
  'pages.agentSetting.language.polish': 'Polonês',
  'pages.agentSetting.language.catalan': 'Catalão',

  // DeviceManagement page related text
  'pages.devices.title': 'Gerenciar Dispositivos',
  'pages.devices.breadcrumb.agents': 'Agentes',
  'pages.devices.breadcrumb.devices': 'Gerenciar Dispositivos',
  'pages.devices.button.addDevice': 'Adicionar Dispositivo',
  'pages.devices.warning.noAgentId': 'Nenhum agentId especificado, não é possível obter a lista de dispositivos',
  'pages.devices.device.unnamed': 'Dispositivo Sem Nome',
  'pages.devices.device.macAddress': 'Endereço Mac',
  'pages.devices.device.lastActive': 'Último Ativo',
  'pages.devices.device.firmwareVersion': 'Versão do Firmware',
  'pages.devices.device.otaUpgrade': 'Atualização OTA',
  'pages.devices.device.noData': 'Sem Dados',
  'pages.devices.copy.success': 'Endereço MAC copiado',
  'pages.devices.unbind.title': 'Confirmar Desvinculação do Dispositivo',
  'pages.devices.unbind.content': 'A desvinculação do dispositivo não pode ser recuperada. Se precisar usar novamente, será necessário vinculá-lo novamente. Tem certeza de que deseja desvincular?',
  'pages.devices.unbind.confirm': 'Confirmar Desvinculação',
  'pages.devices.unbind.cancel': 'Cancelar',
  'pages.devices.unbind.success': 'Dispositivo desvinculado',
  'pages.devices.unbind.error': 'Falha na desvinculação',
  'pages.devices.ota.enabled': 'Atualização OTA habilitada',
  'pages.devices.ota.disabled': 'Atualização OTA desabilitada',
  
  // HistoryDialogs page related text
  'pages.historyDialogs.title': 'Diálogos do Histórico',
  'pages.historyDialogs.breadcrumb.agents': 'Agentes',
  'pages.historyDialogs.breadcrumb.historyDialogs': 'Diálogos do Histórico',
  'pages.historyDialogs.empty.title': 'Nenhuma conversa selecionada',
  'pages.historyDialogs.empty.description': 'Por favor, selecione uma conversa',
  'pages.historyDialogs.agent': 'Agente',
  'pages.historyDialogs.agent.id': 'id',
  'pages.historyDialogs.conversationDetail': 'Detalhes da Conversa',
  'pages.historyDialogs.selectConversation': 'Por favor, selecione uma conversa',
  'pages.historyDialogs.delete.title': 'Excluir Conversa',
  'pages.historyDialogs.delete.content': 'A conversa não pode ser recuperada após a exclusão. Por favor, confirme a operação.',
  'pages.historyDialogs.delete.confirm': 'Confirmar',
  'pages.historyDialogs.delete.cancel': 'Cancelar',
  'pages.historyDialogs.message.delete.confirm': 'Tem certeza de que deseja excluir esta mensagem? Ela não pode ser recuperada após a exclusão.',
  'pages.historyDialogs.detail.title': 'Detalhes da Conversa',
  'pages.historyDialogs.agent.label': 'Agente:',
  'pages.historyDialogs.user.label': 'Usuário:',
  'pages.historyDialogs.loading': 'Carregando...',
  'pages.historyDialogs.error.loadFailed': 'Falha ao carregar lista de conversas',
  'pages.historyDialogs.error.deleteFailed': 'Falha ao excluir conversa',
  'pages.historyDialogs.success.deleteSuccess': 'Conversa excluída com sucesso',
  
  // MessageList page related text
  'pages.messageList.empty': 'Sem mensagens',
  'pages.messageList.user': 'Usuário',
  'pages.messageList.ai': 'IA',
  
  // Settings page related text
  'pages.settings.basicInfo.title': 'Informações Básicas',
  'pages.settings.avatar.label': 'Avatar:',
  'pages.settings.avatar.change': 'Alterar Avatar',
  'pages.settings.avatar.updateSuccess': 'Avatar atualizado com sucesso',
  'pages.settings.avatar.updateFailed': 'Falha ao atualizar avatar',
  'pages.settings.username.label': 'Nome de usuário:',
  'pages.settings.nickname.label': 'Apelido:',
  'pages.settings.nickname.change': 'Editar Apelido',
  'pages.settings.nickname.modal.title': 'Editar Apelido',
  'pages.settings.nickname.form.label': 'Novo Apelido',
  'pages.settings.nickname.form.required': 'Por favor, insira o novo apelido',
  'pages.settings.nickname.form.length': 'O comprimento do apelido deve ser de 2-20 caracteres',
  'pages.settings.nickname.updateSuccess': 'Apelido atualizado com sucesso',
  'pages.settings.nickname.updateFailed': 'Falha ao atualizar apelido',
  'pages.settings.registerTime.label': 'Horário de Registro:',
  'pages.settings.email.label': 'Email:',
  'pages.settings.email.unbind': 'Não vinculado',
  'pages.settings.email.bind': 'Vincular Email',
  'pages.settings.email.change': 'Alterar Email',
  'pages.settings.email.modal.title': 'Vincular Email',
  'pages.settings.email.modal.changeTitle': 'Alterar Email',
  'pages.settings.email.form.label': 'Email',
  'pages.settings.email.form.required': 'Por favor, insira o email',
  'pages.settings.email.form.invalid': 'Formato de email inválido',
  'pages.settings.email.bindSuccess': 'Email vinculado com sucesso',
  'pages.settings.email.bindFailed': 'Falha ao vincular email',
  'pages.settings.changePassword.title': 'Alterar Senha',
  'pages.settings.changePassword.button': 'Alterar Senha',
  'pages.settings.changePassword.modal.title': 'Alterar Senha',
  'pages.settings.changePassword.oldPassword.label': 'Senha Antiga',
  'pages.settings.changePassword.oldPassword.required': 'Por favor, insira a senha antiga',
  'pages.settings.changePassword.newPassword.label': 'Nova Senha',
  'pages.settings.changePassword.newPassword.required': 'Por favor, insira a nova senha',
  'pages.settings.changePassword.newPassword.min': 'A nova senha deve ter pelo menos 6 caracteres',
  'pages.settings.changePassword.confirmPassword.label': 'Confirmar Nova Senha',
  'pages.settings.changePassword.confirmPassword.required': 'Por favor, confirme a nova senha',
  'pages.settings.changePassword.confirmPassword.mismatch': 'As senhas não coincidem',
  'pages.settings.changePassword.success': 'Senha alterada com sucesso',
  'pages.settings.changePassword.failed': 'Falha ao alterar senha',
  'pages.settings.deleteAccount.title': 'Excluir Conta',
  'pages.settings.deleteAccount.button': 'Excluir Conta',
  'pages.settings.deleteAccount.confirm.title': 'Confirmar Exclusão da Conta?',
  'pages.settings.deleteAccount.confirm.content': 'Esta operação não pode ser desfeita. Tem certeza de que deseja excluir sua conta?',
  'pages.settings.deleteAccount.confirm.ok': 'Excluir',
  'pages.settings.deleteAccount.confirm.cancel': 'Cancelar',
  'pages.settings.deleteAccount.success': 'Conta excluída com sucesso',
  'pages.settings.deleteAccount.failed': 'Falha ao excluir conta',
  'pages.settings.profile.fetchFailed': 'Falha ao buscar informações do usuário',
  'pages.settings.form.submit': 'Enviar',
  'pages.settings.password.title': 'Configurações de Senha',
  'pages.settings.basicInfo.username': 'Nome de usuário',
  'pages.settings.basicInfo.nickname': 'Apelido',
  'pages.settings.basicInfo.avatar': 'Avatar',
  'pages.settings.basicInfo.editNickname': 'Editar Apelido',
  'pages.settings.basicInfo.editNicknameTitle': 'Editar Apelido',
  'pages.settings.basicInfo.newNicknameLabel': 'Novo Apelido',
  'pages.settings.basicInfo.nicknameChangeSuccess': 'Apelido alterado com sucesso',
  'pages.settings.basicInfo.openId': 'OpenID:',
  'pages.settings.submit': 'Enviar',
  'pages.settings.deleteAccount.confirmTitle': 'Confirmar Exclusão da Conta',
  'pages.settings.deleteAccount.confirmContent': 'Após excluir sua conta, todos os seus dados serão permanentemente excluídos e não podem ser recuperados, e você não poderá mais fazer login com esta conta. Proceda com cuidado!',
  'pages.settings.deleteAccount.cancel': 'Cancelar',
  'pages.settings.deleteAccount.confirm': 'Confirmar Exclusão',
  
  // Admin Dashboard
  'pages.admin.dashboard.userCount': 'Contagem de Usuários',
  'pages.admin.dashboard.deviceCount': 'Contagem de Dispositivos', 
  'pages.admin.dashboard.agentCount': 'Contagem de Agentes',
  'pages.admin.dashboard.onlineUsers': 'Usuários Online',
  'pages.admin.dashboard.sessionDevices': 'Dispositivos de Sessão',
  'pages.admin.dashboard.memoryUsage': 'Uso de Memória',
  'pages.admin.dashboard.cpuUsage': 'Uso de CPU',
  'pages.admin.dashboard.fetchError': 'Falha ao buscar dados',
  'pages.admin.dashboard.networkError': 'Erro de Rede',

  // Admin User Management
  'pages.admin.user.id': 'ID',
  'pages.admin.user.username': 'Nome de usuário',
  'pages.admin.user.email': 'Email',
  'pages.admin.user.status': 'Status',
  'pages.admin.user.status.all': 'Todos',
  'pages.admin.user.status.disabled': 'Desabilitado',
  'pages.admin.user.status.normal': 'Normal',
  'pages.admin.user.quotaUsed': 'Cota Diária Usada',
  'pages.admin.user.quotaTotal': 'Cota Diária Total',
  'pages.admin.user.createdAt': 'Criado em',
  'pages.admin.user.operations': 'Operações',
  'pages.admin.user.edit': 'Editar',
  'pages.admin.user.detail': 'Detalhe',
  'pages.admin.user.editModal.title': 'Editar Usuário',
  'pages.admin.user.status.label': 'Status do Usuário',
  'pages.admin.user.status.enable': 'Habilitar',
  'pages.admin.user.status.disable': 'Desabilitar',
  'pages.admin.user.quotaUsed.label': 'Cota Diária Usada',
  'pages.admin.user.quotaTotal.label': 'Cota Diária Total',
  'pages.admin.user.email.label': 'Email',
  'pages.admin.user.save.success': 'Salvar bem-sucedido',
  'pages.admin.user.save.failed': 'Falha ao salvar',
  'pages.admin.user.list.title': 'Lista de Usuários',

  // Admin Model Providers
  'pages.admin.providers.title': 'Gerenciamento de Provedores de Modelo',
  'pages.admin.providers.total': 'Total de {total} provedores',
  'pages.admin.providers.stats': 'ASR: {asr}, TTS: {tts}, LLM: {llm}, VLLLM: {vlllm}',
  'pages.admin.providers.addNew': 'Adicionar Novo Provedor',
  'pages.admin.providers.search.placeholder': 'Pesquisar nome do provedor, endpoint ou modelo...',
  'pages.admin.providers.filter.all': 'Todos os Tipos',
  'pages.admin.providers.filter.asr': 'ASR - Reconhecimento de Fala',
  'pages.admin.providers.filter.tts': 'TTS - Texto para Fala', 
  'pages.admin.providers.filter.llm': 'LLM - Modelo de Linguagem Grande',
  'pages.admin.providers.filter.vlllm': 'VLLLM - Modelo de Linguagem Visual',
  'pages.admin.providers.empty.noProviders': 'Ainda não há provedores',
  'pages.admin.providers.empty.noMatches': 'Nenhum provedor correspondente encontrado',
  'pages.admin.providers.empty.addFirst': 'Clique no botão acima para adicionar seu primeiro provedor de modelo',
  'pages.admin.providers.empty.adjustFilters': 'Tente ajustar os critérios de pesquisa ou filtros',
  'pages.admin.providers.type.asr': 'ASR - Reconhecimento de Fala',
  'pages.admin.providers.type.tts': 'TTS - Texto para Fala',
  'pages.admin.providers.type.llm': 'LLM - Modelo de Linguagem Grande',
  'pages.admin.providers.type.vlllm': 'VLLLM - Modelo de Linguagem Visual',
  'pages.admin.providers.success.created': 'Provedor adicionado com sucesso!',
  'pages.admin.providers.success.updated': 'Provedor atualizado com sucesso!',
  'pages.admin.providers.success.deleted': 'Provedor excluído com sucesso!',
  'pages.admin.providers.success.statusToggled': 'Status alternado com sucesso!',
  'pages.admin.providers.error.createFailed': 'Falha ao adicionar provedor, tente novamente',
  'pages.admin.providers.error.updateFailed': 'Falha ao atualizar provedor, tente novamente',
  'pages.admin.providers.error.deleteFailed': 'Falha ao excluir provedor, tente novamente',
  'pages.admin.providers.error.testFailed': 'Teste de conexão falhou, verifique a rede ou configuração',
  'pages.admin.providers.error.toggleFailed': 'Falha ao alternar status, tente novamente',
  'pages.admin.providers.error.loadFailed': 'Falha ao carregar lista de provedores, atualize a página',

  // Admin Settings
  'pages.admin.settings.title': 'Configurações do Sistema',
  'pages.admin.settings.asr.label': 'Serviço ASR',
  'pages.admin.settings.asr.placeholder': 'Selecionar Serviço ASR',
  'pages.admin.settings.tts.label': 'Serviço TTS',
  'pages.admin.settings.tts.placeholder': 'Selecionar Serviço TTS',
  'pages.admin.settings.llm.label': 'Serviço LLM',
  'pages.admin.settings.llm.placeholder': 'Selecionar Serviço LLM',
  'pages.admin.settings.vlllm.label': 'Serviço VLLLM',
  'pages.admin.settings.vlllm.placeholder': 'Selecionar Serviço VLLLM',
  'pages.admin.settings.prompt.label': 'Configurações de Prompt',
  'pages.admin.settings.prompt.placeholder': 'Por favor, insira o prompt do sistema...',
  'pages.admin.settings.quickReply.label': 'Palavras de Resposta Rápida',
  'pages.admin.settings.quickReply.placeholder': 'Inserir nova palavra de resposta rápida',
  'pages.admin.settings.quickReply.add': 'Adicionar',
  'pages.admin.settings.deleteAudio.label': 'Excluir Áudio',
  'pages.admin.settings.deleteAudio.enabled': 'Habilitado',
  'pages.admin.settings.deleteAudio.disabled': 'Desabilitado',
  'pages.admin.settings.usePrivateConfig': 'Usar Configuração Privada',
  'pages.admin.settings.save': 'Salvar Configuração',
  'pages.admin.settings.saving': 'Salvando...',
  'pages.admin.settings.reset': 'Redefinir',
  'pages.admin.settings.success.saved': 'Configuração salva com sucesso!',
  'pages.admin.settings.error.saveFailed': 'Falha ao salvar configuração, tente novamente',
  'pages.admin.settings.error.loadFailed': 'Falha ao carregar configuração, atualize a página e tente novamente',


  // Add Device Dialog
  'pages.addDevice.modal.title': 'Adicionar Dispositivo',
  'pages.addDevice.verificationCode.label': 'Código de Verificação:',
  'pages.addDevice.verificationCode.placeholder': 'Por favor, insira o código de verificação de 6 dígitos do dispositivo',
  'pages.addDevice.verificationCode.required': 'Por favor, insira um código de verificação de 6 dígitos',
  'pages.addDevice.verificationCode.error': 'Por favor, insira um código de verificação de 6 dígitos',

  // Provider Modal
  'pages.admin.providerModal.edit.title': 'Editar Provedor',
  'pages.admin.providerModal.add.title': 'Adicionar Novo Provedor',
  'pages.admin.providerModal.name.label': 'Nome do Provedor *',
  'pages.admin.providerModal.name.placeholder': 'ex.: OpenAI, Doubao TTS',
  'pages.admin.providerModal.name.required': 'Por favor, insira o nome do provedor',
  'pages.admin.providerModal.type.label': 'Categoria de Serviço *',
  'pages.admin.providerModal.subType.label': 'Tipo Específico *',
  'pages.admin.providerModal.subType.required': 'Por favor, selecione o tipo específico',
  'pages.admin.providerModal.config.title': 'Configuração',
  'pages.admin.providerModal.api.url.label': 'URL da API *',
  'pages.admin.providerModal.api.url.required': 'Por favor, insira a URL da API',
  'pages.admin.providerModal.model.name.label': 'Nome do Modelo *',
  'pages.admin.providerModal.model.name.required': 'Por favor, insira o nome do modelo',
  'pages.admin.providerModal.api.key.label': 'Chave da API *',
  'pages.admin.providerModal.api.key.required': 'Por favor, insira a chave da API',
  'pages.admin.providerModal.temperature.label': 'Temperatura (0-2)',
  'pages.admin.providerModal.temperature.error': 'A temperatura deve estar entre 0-2',
  'pages.admin.providerModal.maxTokens.label': 'Tokens Máximos',
  'pages.admin.providerModal.maxTokens.error': 'Os tokens máximos devem estar entre 1-32768',
  'pages.admin.providerModal.topP.label': 'Top-P',
  'pages.admin.providerModal.appid.label': 'ID do App *',
  'pages.admin.providerModal.appid.required': 'Por favor, insira o ID do App',
  'pages.admin.providerModal.accessToken.label': 'Token de Acesso *',
  'pages.admin.providerModal.accessToken.required': 'Por favor, insira o token de acesso',
  'pages.admin.providerModal.cluster.label': 'Cluster',
  'pages.admin.providerModal.grpc.host.label': 'Host gRPC *',
  'pages.admin.providerModal.grpc.host.required': 'Por favor, insira o endereço do host gRPC',
  'pages.admin.providerModal.grpc.port.label': 'Porta gRPC *',
  'pages.admin.providerModal.grpc.port.required': 'Por favor, insira a porta gRPC',
  'pages.admin.providerModal.voice.label': 'Voz *',
  'pages.admin.providerModal.voice.required': 'Por favor, insira o tipo de voz',
  'pages.admin.providerModal.token.label': 'Token *',
  'pages.admin.providerModal.token.required': 'Por favor, insira o token',
  'pages.admin.providerModal.websocket.label': 'URL WebSocket *',
  'pages.admin.providerModal.websocket.required': 'Por favor, insira a URL WebSocket',
  'pages.admin.providerModal.siliconflow.apiKey.label': 'Chave da API *',
  'pages.admin.providerModal.siliconflow.apiKey.required': 'Por favor, insira a chave da API',
  'pages.admin.providerModal.siliconflow.baseUrl.label': 'URL da API',
  'pages.admin.providerModal.manage.voices': 'Gerenciar Vozes',
  'pages.admin.providerModal.edge.noConfig': 'Microsoft Edge TTS não requer configuração adicional',
  'pages.admin.providerModal.submit.error': 'Falha no envio, tente novamente',

  // Provider Card
  'pages.admin.providerCard.status.active': 'Ativo',
  'pages.admin.providerCard.status.inactive': 'Offline',
  'pages.admin.providerCard.status.error': 'Erro',
  'pages.admin.providerCard.status.unknown': 'Desconhecido',
  'pages.admin.providerCard.warning.readonly.test': 'Permissão somente leitura, não é possível testar o provedor',
  'pages.admin.providerCard.warning.readonly.delete': 'Permissão somente leitura, não é possível excluir o provedor',
  'pages.admin.providerCard.warning.readonly.edit': 'Permissão somente leitura, não é possível editar o provedor',
  'pages.admin.providerCard.warning.readonly.toggle': 'Permissão somente leitura, não é possível alternar o status',
  'pages.admin.providerCard.button.disable': 'Desabilitar',
  'pages.admin.providerCard.button.enable': 'Habilitar',
  'pages.admin.providerCard.button.testing': 'Testando...',
  'pages.admin.providerCard.button.test': 'Testar',
  'pages.admin.providerCard.button.edit': 'Editar',
  'pages.admin.providerCard.button.delete': 'Excluir',
  'pages.admin.providerCard.delete.title': 'Tem certeza de que deseja excluir este item?',
  'pages.admin.providerCard.delete.content': 'Não pode ser recuperado após a exclusão, confirme a operação.',
  'pages.admin.providerCard.config.type': 'Tipo',
  'pages.admin.providerCard.config.apiUrl': 'URL da API',
  'pages.admin.providerCard.config.model': 'Modelo',
  'pages.admin.providerCard.config.apiKey': 'Chave da API',
  'pages.admin.providerCard.config.temperature': 'Temperatura',
  'pages.admin.providerCard.config.maxTokens': 'Tokens Máximos',
  'pages.admin.providerCard.config.appid': 'ID do App',
  'pages.admin.providerCard.config.cluster': 'Cluster',
  'pages.admin.providerCard.config.accessToken': 'Token de Acesso',
  'pages.admin.providerCard.config.grpcHost': 'Host gRPC',
  'pages.admin.providerCard.config.grpcPort': 'Porta gRPC',
  'pages.admin.providerCard.config.voice': 'Voz',
  'pages.admin.providerCard.config.format': 'Formato',
  'pages.admin.providerCard.config.token': 'Token',
  'pages.admin.providerCard.config.outputDir': 'Diretório de Saída',
  'pages.admin.providerCard.voices.supported': 'Vozes Suportadas',
  'pages.admin.providerCard.voices.count': '',
  'pages.admin.providerCard.test.failed': 'Teste falhou',

    // OpsManage
  'pages.admin.ops.service.title': 'Gerenciamento de Serviços',
  'pages.admin.ops.upload.button': 'Enviar Arquivo de Serviço',
  'pages.admin.ops.upload.success': 'Arquivo de serviço enviado com sucesso',
  'pages.admin.ops.upload.error': 'Falha no envio do arquivo de serviço',
  'pages.admin.ops.restart.button': 'Reiniciar Serviço',
  'pages.admin.ops.restart.confirmTitle': 'Cuidado: Tem certeza de que deseja reiniciar o serviço?',
  'pages.admin.ops.restart.desc': 'Reiniciar o serviço desconectará todas as conexões atuais e tornará o serviço temporariamente indisponível.',
  'pages.admin.ops.restart.warn': 'Esta operação apenas parará o processo de serviço atual. Certifique-se de que um daemon ou script de reinicialização automática esteja configurado no servidor, caso contrário o serviço não se recuperará automaticamente!',
  'pages.admin.ops.restart.ok': 'Confirmar Reinicialização',
  'pages.admin.ops.restart.cancel': 'Cancelar',
  'pages.admin.ops.restart.success': 'Comando de reinicialização do serviço enviado',
  'pages.admin.ops.restart.error': 'Falha na reinicialização do serviço',
  'pages.admin.ops.log.title': 'Visualização e Download de Log',
  'pages.admin.ops.web.upload.button': 'Enviar web.zip',
  'pages.admin.ops.web.upload.success': 'web.zip enviado com sucesso',
  'pages.admin.ops.web.upload.error': 'Falha no envio do web.zip',
  'pages.admin.ops.web.upload.onlyzip': 'Apenas arquivos zip são permitidos',
  'pages.admin.ops.web.update.button': 'Atualizar diretório web',
  'pages.admin.ops.web.update.success': 'Comando de atualização do diretório web enviado',
  'pages.admin.ops.web.update.error': 'Falha na atualização do diretório web',
  'pages.admin.ops.web.upload.onlywebzip': 'Apenas um arquivo chamado web.zip é permitido',

  // Recorder Management
  'pages.admin.recorder.title': 'Gerenciamento de Gravador de Dispositivos',
  'pages.admin.recorder.inputDeviceId': 'Por favor, insira o ID do dispositivo',
  'pages.admin.recorder.inputPlaceholder': 'Por favor, insira o ID do dispositivo',
  'pages.admin.recorder.search': 'Pesquisar',
  'pages.admin.recorder.list.title': 'Lista de Gravadores',
  'pages.admin.recorder.fetchSuccess': 'Registros de gravador recuperados com sucesso',
  'pages.admin.recorder.fetchError': 'Falha ao recuperar lista de gravadores',
  'pages.admin.recorder.empty': 'Sem dados de gravador, insira o ID do dispositivo para pesquisar',
  'pages.admin.recorder.totalCount': 'Estatísticas',
  'pages.admin.recorder.conversationId': 'ID da Conversa',

  'pages.agentSetting.mcp.modal.title': 'Configurações de Endpoint MCP',
  'pages.agentSetting.mcp.modal.statusLabel': 'Status do Endpoint',
  'pages.agentSetting.mcp.modal.online': 'Online',
  'pages.agentSetting.mcp.modal.disconnected': 'Desconectado',
  'pages.agentSetting.mcp.modal.unknown': 'Desconhecido',
  'pages.agentSetting.mcp.modal.refresh': 'Atualizar',
  'pages.agentSetting.mcp.modal.enabledServices': 'Serviços Habilitados',
  'pages.agentSetting.mcp.modal.endpointLabel': 'Endereço do Endpoint',
  'pages.agentSetting.mcp.modal.endpointDesc': 'Abaixo está o endereço do endpoint MCP do agente.',
  'pages.agentSetting.mcp.modal.docLink': 'Visualizar Documentação do Endpoint',
  'pages.agentSetting.mcp.modal.noEndpoint': 'Nenhum Endpoint Disponível',
  'pages.agentSetting.mcp.modal.hide': 'Ocultar',
  'pages.agentSetting.mcp.title': 'Configurações MCP', 
  'pages.agentSetting.mcp.customService': 'Serviço Personalizado',
  'pages.agentSetting.mcp.officialServices': 'Serviços Oficiais',
  'pages.agentSetting.mcp.officialServices.placeholder': 'Selecionar Serviços Oficiais',
  'pages.agentSetting.mcp.services.weather': 'Clima',
  'pages.agentSetting.mcp.services.joke': 'Piada',
  'pages.agentSetting.mcp.services.music': 'Música',
  'pages.agentSetting.mcp.services.news': 'Notícias',
  'pages.agentSetting.mcp.error.missingId': 'ID do Agente Faltando, não é possível recuperar o endpoint',
  'pages.agentSetting.mcp.error.noEndpoint': 'Não foi possível recuperar o endpoint do servidor',
'pages.agentSetting.mcp.error.fetchFailed': 'Falha ao recuperar o endpoint',
  'pages.agentSetting.mcp.button.getEndpoint': 'Obter Endpoint MCP',

  // Memory settings
  'pages.agentSetting.memory.title': 'Memória de Curto Prazo',
  'pages.agentSetting.memory.type.label': 'Tipo de Memória',
  'pages.agentSetting.memory.type.none': 'Sem Memória',
  'pages.agentSetting.memory.type.shortTerm': 'Memória de Curto Prazo',
  'pages.agentSetting.memory.current.label.short': 'Memória Atual',
  'pages.agentSetting.memory.current.help': 'Regenerada após cada conversa',
  'pages.agentSetting.memory.clear': 'Limpar Memória',
  'pages.agentSetting.memory.clear.tip': 'Memória marcada para limpeza, clique em salvar para aplicar',
  'pages.agentSetting.memory.content.label': 'Conteúdo da Memória',
  'pages.agentSetting.memory.content.placeholder': 'Obter conteúdo da memória de curto prazo mais recente do agente',
  'pages.agentSetting.memory.content.editPlaceholder': 'Por favor, insira o conteúdo da memória',
  'pages.agentSetting.memory.edit': 'Editar Memória',
  'pages.agentSetting.memory.edit.success': 'Memória atualizada, por favor salve para aplicar',
  'pages.agentSetting.memory.edit.save': 'Salvar Alterações',
  'pages.agentSetting.memory.edit.cancel': 'Cancelar',

  // Botões e operações comuns
  'pages.common.cancel': 'Cancelar',

  // Configuração do sistema
  'pages.admin.systemConfig.roleName': 'Nome do Papel',
  'pages.admin.systemConfig.roleDesc': 'Descrição do Papel',
  'pages.admin.systemConfig.enabled': 'Status Ativado',
  'pages.admin.systemConfig.featureName': 'Nome da Funcionalidade',
  'pages.admin.systemConfig.featureDesc': 'Descrição da Funcionalidade',
  'pages.admin.systemConfig.exitCommand': 'Comando de Saída',
  'pages.admin.systemConfig.mcpName': 'Nome MCP',
  'pages.admin.systemConfig.newNameOptional': 'Novo Nome (Opcional)',
  'pages.admin.systemConfig.configJson': 'Config JSON',
  'pages.admin.systemConfig.useDeviceCode': 'Usar Código do Dispositivo',
  'pages.admin.systemConfig.quickReply': 'Resposta Rápida',
  'pages.admin.systemConfig.shortTermMemory': 'Memória de Curto Prazo',
  'pages.admin.systemConfig.saveUserAudio': 'Salvar Arquivos de Áudio do Usuário',
  'pages.admin.systemConfig.enableWhiteList': 'Ativar Lista Branca',
  'pages.admin.systemConfig.speakerDetect': 'Reconhecimento de Voz',
  'pages.admin.systemConfig.recorderManagerEnable': 'Ativar Gerenciamento de Gravador',
  'pages.admin.systemConfig.voiceCloneEnable': 'Ativar Clone de Voz',
  'pages.admin.systemConfig.flattenedChatHistory': 'Histórico de Chat Achatado',
  'pages.admin.systemConfig.dialogueHistoryLength': 'Comprimento do Histórico de Diálogo',
  'pages.admin.systemConfig.userTotalQuota': 'Cota Total do Usuário',
  'pages.admin.systemConfig.dailyClearQuota': 'Cota Diária',
  'pages.admin.systemConfig.checkDeviceModeImmediately': 'Verificar Modo do Dispositivo Imediatamente',
  'pages.admin.systemConfig.defaultObserverUserOnRegister': 'Papel de Observador Padrão para Novos Usuários',
  'pages.admin.systemConfig.status': 'Status',
  'pages.admin.systemConfig.port': 'Porta',
  'pages.admin.systemConfig.udpShowPort': 'Mostrar Porta',
  'pages.admin.systemConfig.accessToken': 'Token de Acesso',
  'pages.admin.systemConfig.activateText': 'Texto de Ativação',
  'pages.admin.systemConfig.logLevel': 'Nível de Log',
  'pages.admin.systemConfig.logDir': 'Diretório de Log',
  'pages.admin.systemConfig.logFileName': 'Nome do Arquivo de Log',

  // Clone de Voz
  'pages.console.voiceClone.name': 'Nome',
  'pages.console.voiceClone.provider': 'Provedor',
  'pages.console.voiceClone.mode': 'Modo',
  'pages.console.voiceClone.record': 'Gravar',
  'pages.console.voiceClone.upload': 'Enviar',

  // Reconhecimento de Voz
  'pages.console.speakers.name': 'Nome',
  'pages.console.speakers.mode': 'Modo',
  'pages.console.speakers.record': 'Gravar',
  'pages.console.speakers.upload': 'Enviar',

  // Configuração da Página
  'pages.console.settings.email': 'Email',
  'pages.console.settings.oldPassword': 'Senha Antiga',
  'pages.console.settings.newPassword': 'Nova Senha',
  'pages.console.settings.confirmNewPassword': 'Confirmar Nova Senha',

  // Provedor VLLM
  'pages.providers.vllm.maxPixels': 'Máximo de Pixels',
  'pages.admin.providerModal.copyAsNew': 'Copiar como Novo Provedor',

  'pages.unbindDevice.cardTitle': 'Desvincular dispositivo',
  'pages.whiteList.cardTitle': 'Gerenciamento de lista branca',
  'pages.admin.ops.logViewer.previewTitle': 'Visualização de registro',
  'pages.admin.ops.logViewer.fileName': 'Nome do arquivo:',
  'pages.admin.ops.logViewer.lineCount': 'Número de linhas:',
  'pages.admin.ops.logViewer.previewBtn': 'Visualizar',
  'pages.admin.ops.logViewer.noContent': 'Sem conteúdo',
  'pages.admin.devices': 'Gerenciamento de dispositivos',
  'pages.admin.unbindDevice': 'Desvincular dispositivo',
  'pages.admin.deviceManage': 'Gerenciamento de dispositivos',
  'pages.systemConfig.quickReply': 'Resposta rápida',
  'pages.systemConfig.useShortTermMemory': 'Memória de curto prazo',
  'pages.systemConfig.useShortTermMemory.desc': 'Quando ativado, o sistema usa um mecanismo de memória de curto prazo e a atualiza após cada rodada de diálogo. Quando desativado, a memória de curto prazo não é usada.',
  'pages.agentSetting.mcp.modal.show': 'Mostrar',
  'pages.agentSetting.mcp.modal.copied': 'Copiado',
  'pages.agentSetting.mcp.modal.copy': 'Copiar',
  'pages.admin.providerModal.model.label': 'Modelo *',
  'pages.admin.providerModal.model.placeholder': 'Digite o nome do modelo',
  'pages.admin.providerModal.model.required': 'Digite o nome do modelo',
  'pages.admin.providerModal.security.title': 'Configurações de segurança',
  'pages.admin.providerModal.appid.placeholder': 'ID do aplicativo Doubao',
  'pages.admin.providerModal.accessToken.placeholder': 'Token de acesso',
  'pages.admin.providerModal.grpc.addr.label': 'Endereço gRPC (Host:Porta) *',
  'pages.admin.providerModal.grpc.addr.required': 'Digite o endereço gRPC (Host:Porta)',
  'pages.admin.providerModal.token.placeholder': 'Token Doubao',
  'pages.admin.providerModal.siliconflow.apiKey.placeholder': 'Chave API',
  'pages.admin.providerModal.manageVoices': 'Gerenciar vozes',
  'pages.admin.whiteList.inputMac': 'Digite o endereço MAC',
  'pages.admin.whiteList.batchAdd': 'Adicionar em lote',
  'pages.admin.whiteList.add': 'Adicionar',
  'pages.admin.whiteList.list.title': 'Lista de endereços MAC',
  'pages.admin.whiteList.selectCsvTip': 'Selecione um arquivo CSV',
  'pages.admin.whiteList.uploadSuccess': 'Upload bem-sucedido',
  'pages.admin.whiteList.uploadFailed': 'Falha no upload',
  'pages.admin.whiteList.invalidMac': 'Digite um endereço MAC válido',
  'pages.admin.settings.voiceCloneEnable': 'Ativar clonagem de voz',
  'pages.agentSetting.roleTemplate.empty': 'Nenhum modelo disponível. Verifique role_template.json',
  'pages.admin.providerModal.save': 'Salvar',
  'pages.contractDevice.cardTitle': 'Gerenciamento de dispositivos contratuais',
  'pages.contractDevice.mac': 'Endereço MAC',
  'pages.contractDevice.protocolType': 'Tipo de protocolo',
  'pages.contractDevice.status': 'Status',
  'pages.contractDevice.expireTime': 'Data de vencimento',
  'pages.contractDevice.updateTime': 'Hora de atualização',
  'pages.contractDevice.operations': 'Operações',
  'pages.contractDevice.edit': 'Editar',
  'pages.contractDevice.delete': 'Excluir',
  'pages.contractDevice.deleteConfirm': 'Confirmar exclusão',
  'pages.contractDevice.addTitle': 'Adicionar dispositivo contratual',
  'pages.contractDevice.batchAddTitle': 'Adicionar em lote',
  'pages.contractDevice.editTitle': 'Editar dispositivo contratual',
  'pages.contractDevice.listTitle': 'Lista de dispositivos contratuais',
  'pages.contractDevice.add': 'Adicionar',
  'pages.contractDevice.batchAdd': 'Adicionar em lote',
  'pages.contractDevice.selectCsvTip': 'Selecione um arquivo CSV',
  'pages.contractDevice.uploadSuccess': 'Upload bem-sucedido',
  'pages.contractDevice.macRequired': 'Digite o endereço MAC',
  'pages.contractDevice.protocolTypeRequired': 'Selecione o tipo de protocolo',
  'pages.contractDevice.statusRequired': 'Selecione o status',
  'pages.contractDevice.expireTimeRequired': 'Selecione a data de vencimento',
};